export default [
  {
    path: '/revistas',
    name: 'list_magazine',
    component: () => import('./pages/ListMagazine.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Revistas',
      breadcrumb: [
        {
          text: 'revistas',
          active: true,
        }
      ],
    },
  },
]
